import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const { refresh } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async (n = 0) => {
      if (cancelled) return;
      if (n >= 15) { setStatus("timeout"); return; }
      try {
        const { data } = await client.get(`/payments/status/${session_id}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") {
          setStatus("failed");
          return;
        }
      } catch (e) { /* keep polling */ }
      setAttempts(n + 1);
      setTimeout(() => poll(n + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [session_id]);

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-6 py-16">
      <div className="surface p-12 max-w-md w-full text-center" data-testid="payment-status-card">
        {status === "polling" && (<>
          <Loader2 size={48} className="text-[#CCFF00] animate-spin mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_processing")}</h2>
          <div className="mt-2 text-xs font-mono text-white/40">Attempt {attempts}/15</div>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 size={48} className="text-[#CCFF00] mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_success")}</h2>
          <button data-testid="payment-success-dashboard-button" onClick={() => nav("/dashboard")} className="btn-acid mt-8">Go to Dashboard</button>
        </>)}
        {(status === "failed" || status === "timeout" || status === "error") && (<>
          <XCircle size={48} className="text-[#FF3366] mx-auto" />
          <h2 className="font-display text-2xl mt-6">{t("payment_failed")}</h2>
          <button onClick={() => nav("/programs")} className="btn-ghost mt-8">Back to Programs</button>
        </>)}
      </div>
    </div>
  );
}
